import { IonRouterLink } from '@ionic/react'
import { format, parseISO } from 'date-fns'

import { Card, CardContent } from '../../../components/ui/card'

import type { ClientStation } from '../paired.schema'

type Props = { href?: string; stationClient: ClientStation }

function CheckInListItem({ href, stationClient }: Props) {
  const { client, completedAt, pointsEarned, rewardsApplied, station } =
    stationClient
  return (
    <Card>
      <CardContent>
        <IonRouterLink routerLink={href} routerDirection="forward">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-2xl font-semibold">{client?.displayName}</p>
              <p className="text-lg">
                {completedAt
                  ? format(parseISO(completedAt.iso), 'MMM do, h:mm aaa')
                  : 'NO DATE'}
              </p>
              <p>{station?.name || 'Unknown Station'}</p>
            </div>
            <div className="flex flex-col text-lg">
              <span>Points Earned: {pointsEarned}</span>
              <span>Rewards Claimed: {rewardsApplied}</span>
            </div>
          </div>
        </IonRouterLink>
      </CardContent>
    </Card>
  )
}

export { CheckInListItem }
